import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const BrandNavigationSlider = styled.section`
  background-color: ${({ theme }) => theme.secondary.main};
  z-index: 5;
  position: relative;
`;

export const SliderTitle = styled.h2`
  font-size: 20px;
  color: ${({ theme }) => theme.base.white};
  width: 100%;
  box-sizing: border-box;
  padding: 16px 16px 0 16px;

  ${breakpoints.lg} {
    padding: 25px 16px 0 40px;
  }
`;

export const Arrow = styled.button`
  width: 20px;
  height: 40px;
  background-color: ${({ theme }) => theme.primary.main};
  display: block;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: 0;
  z-index: 1;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);

  &:hover {
    background: ${({ theme }) => theme.primary.light};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.base.blue};
    border: 1px solid transparent;
  }

  &:active {
    background: ${({ theme }) => theme.primary.dark};
  }

  ${breakpoints.md} {
    width: 40px;
    height: 80px;
  }

  svg {
    fill: ${({ theme }) => theme.primary.contrastText};
    margin-left: 0px;
    height: 15px;
    width: 15px;

    ${breakpoints.md} {
      height: 25px;
      width: 25px;
    }

    ${breakpoints.lg} {
      height: 25px;
      width: 25px;
    }
  }
`;

export const PrevArrow = styled(Arrow)`
  left: -16px;

  ${breakpoints.md} {
    left: -20px;
  }

  ${breakpoints.lg} {
    left: ${(props) => (props.isBrand ? '30px' : '-20px')};
  }

  svg {
    transform: rotate(-180deg);
    margin-right: 0;
  }
`;

export const NextArrow = styled(Arrow)`
  right: -16px;

  ${breakpoints.md} {
    right: -20px;
  }

  ${breakpoints.lg} {
    right: ${(props) => (props.isBrand ? '30px' : '-20px')};
  }
`;
